import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    noData: 'No data',
    selectAll: 'Select all',
    unselectAll: 'Unselect all',
    selectRow: 'Select row',
    deselectRow: 'Deselect row',
    expandRow: 'Expand row',
    collapseRow: 'Collapse row',
    loading: 'Loading…',
    apply: 'Apply',
    clear: 'Clear'
  },
  {
    ns: 'table'
  }
)
